import { WebinarsApi } from 'api';
import { useState, useEffect } from 'react';

export const useWebinarStatistics = () => {
  const [loaded, setLoaded] = useState(false);
  const [data, setData] = useState({ activated_teachers: 0, rewarded_teachers: 0 });
  useEffect(() => {
    const fetchData = async () => {
      const result = await WebinarsApi.getStatistics();
      setData(result);
      setLoaded(true);
    };
    fetchData();
  }, []);

  return { loaded, data };
};
